import { render } from "./data-table.vue?vue&type=template&id=b5d153f6&scoped=true"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"

import "./data-table.vue?vue&type=style&index=0&id=b5d153f6&scoped=true&lang=css"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d153f6"]])

export default __exports__